import { DependencyList, useEffect, useRef } from 'react';
import { MonoTypeOperatorFunction, OperatorFunction, Subject } from 'rxjs';

export const useSubject = <TSubscriptionArguments>(
    subscription: (value: TSubscriptionArguments) => void,
    deps?: DependencyList | (MonoTypeOperatorFunction<any> | OperatorFunction<any, any>),
    ...pipe: (MonoTypeOperatorFunction<any> | OperatorFunction<any, any>)[]
) => {
    const subject$ = useRef(new Subject<TSubscriptionArguments>());
    if (!deps) {
        deps = [];
    }
    if (!Array.isArray(deps)) {
        pipe.unshift(deps as MonoTypeOperatorFunction<any> | OperatorFunction<any, any>);
        deps = [];
    }

    useEffect(() => {
        // @ts-ignore ignore the pipe tuple typescript error
        const eventSubscription = subject$.current.pipe(...pipe).subscribe(subscription);

        return () => {
            eventSubscription.unsubscribe();
        };
    }, deps as DependencyList);

    return subject$.current;
};
